module.exports = __webpack_public_path__ + "static/media/Performance.5d8199f2.png";